import twttr, { UrlEntity } from 'twitter-text'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'

export const getTwitterComplianceText = (text: string, mentionedUrls: RichMentionedUrl[]) => {
  if (!mentionedUrls || mentionedUrls.length === 0) {
    return twttr.autoLink(text, {
      targetBlank: true,
      usernameIncludeSymbol: true,
      hashtagUrlBase: 'https://twitter.com/#!/search?q=%23',
      cashtagUrlBase: 'https://twitter.com/#!/search?q=%24',
      invisibleTagAttrs: "style='display:none;'"
    })
  }

  const entities = twttr.extractEntitiesWithIndices(text)
  const urlEntities: UrlEntity[] = []

  entities
    .filter((entity) => 'url' in entity && entity.url)
    .forEach((entity) =>
      mentionedUrls
        .filter((mentionedUrl) => mentionedUrl.url === (entity as twttr.UrlWithIndices).url)
        .forEach((mentionedUrl) =>
          urlEntities.push({
            url: mentionedUrl.url!,
            display_url: mentionedUrl.displayUrl!,
            expanded_url: mentionedUrl.displayUrl!,
            indices: entity.indices
          })
        )
    )
  return twttr.autoLinkEntities(text, entities, {
    hashtagUrlBase: 'https://twitter.com/#!/search?q=%23',
    cashtagUrlBase: 'https://twitter.com/#!/search?q=%24',
    urlEntities,
    usernameIncludeSymbol: true,
    targetBlank: true,
    invisibleTagAttrs: "style='display:none;'"
  })
}

export default getTwitterComplianceText
